export default __webpack_public_path__ + "static/media/hydrationstation3.cbc59765.png";